import { render, staticRenderFns } from "./MerchantApplications.vue?vue&type=template&id=2eb1b372"
import script from "./MerchantApplications.vue?vue&type=script&lang=js"
export * from "./MerchantApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports